import { useEffect, useRef } from "react"
import './style.css'

export default function Wobble() {
    const ref = useRef(null)

    useEffect(() => {
        const dismiss = () => {
            if (ref.current) ref.current.classList.add('dismissed')
            document.removeEventListener('pointerdown', dismiss)
            document.removeEventListener('touchstart', dismiss)
        }

        document.addEventListener('pointerdown', dismiss, { once: true, passive: true })
        document.addEventListener('touchstart', dismiss, { once: true, passive: true })

        return () => {
            document.removeEventListener('pointerdown', dismiss)
            document.removeEventListener('touchstart', dismiss)
        }
    }, [])

    return <div ref={ref} className="interface-hand"><div className="hand"></div></div>
}
